import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6af53f06"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "demo"
};
import { ref } from "vue";
import { BlitzListForm } from 'blitzar';
import 'blitzar/dist/style.css';
import schema from './schema';
export default {
  setup(__props) {
    const formData = ref([]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(BlitzListForm), {
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value = $event),
        schema: _unref(schema)
      }, null, 8, ["modelValue", "schema"])]);
    };
  }

};